import { Card, CardContent } from '@/components/ui/card';
import { Users, TrendingUp, AlertTriangle, CheckCircle, Clock, Target } from 'lucide-react';

interface ControlRoomKPIsProps {
  totalClients: number;
  avgFocoScore: number;
  clientsWithData: number;
  totalGoals: number;
  criticalAlerts: number;
  pendingTasks: number;
}

export function ControlRoomKPIs({
  totalClients,
  avgFocoScore,
  clientsWithData,
  totalGoals,
  criticalAlerts,
  pendingTasks,
}: ControlRoomKPIsProps) {
  const kpis = [
    {
      label: 'Total Clientes',
      value: totalClients,
      icon: Users,
      color: 'bg-primary/10 text-primary',
    },
    {
      label: 'FOCO Promedio',
      value: Math.round(avgFocoScore),
      icon: TrendingUp,
      color: avgFocoScore >= 60 ? 'bg-success/10 text-success' : avgFocoScore >= 40 ? 'bg-warning/10 text-warning' : 'bg-destructive/10 text-destructive',
    },
    {
      label: 'Con Datos',
      value: clientsWithData,
      icon: CheckCircle,
      color: 'bg-success/10 text-success',
    },
    {
      label: 'Total Metas',
      value: totalGoals,
      icon: Target,
      color: 'bg-accent text-accent-foreground',
    },
    {
      label: 'Alertas Críticas',
      value: criticalAlerts,
      icon: AlertTriangle,
      color: criticalAlerts > 0 ? 'bg-destructive/10 text-destructive' : 'bg-success/10 text-success',
    },
    {
      label: 'Tareas Pendientes',
      value: pendingTasks,
      icon: Clock,
      color: pendingTasks > 0 ? 'bg-warning/10 text-warning' : 'bg-success/10 text-success',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {kpis.map((kpi) => (
        <Card key={kpi.label}>
          <CardContent className="pt-4 pb-4">
            <div className="flex flex-col items-center text-center gap-2">
              <div className={`p-2 rounded-lg ${kpi.color}`}>
                <kpi.icon className="h-5 w-5" />
              </div>
              <p className="text-2xl font-bold">{kpi.value}</p>
              <p className="text-xs text-muted-foreground">{kpi.label}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
